

import { SubDomain } from "../../SubDomain.js";
import Repair from "./Repair.js";

export default class RepairsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Repair.MODEL_NAME);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Repair(this.domain, item);
      }
    }

    return new Repair(this.domain);
  }
}
